import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import Payment from '../components/payment';
import { createOrder } from '../actions';
import { paymentSelector, errorSelector, statusSelector } from '../selector';

const mapDispatchToProps = dispatch => ({
  createOrder: order => dispatch(createOrder(order)),
});

const mapStateToProps = state => {
  const {
    fetchOrder: fetchOrderError,
    payOrder: payOrderError,
    createSource: createSourceError,
  } = errorSelector(['fetchOrder', 'payOrder', 'createSource'])(state);
  const {
    fetchOrder: fetchOrderStatus,
    payOrder: payOrderStatus,
    createSource: createSourceStatus,
  } = statusSelector(['fetchOrder', 'payOrder', 'createSource'])(state);
  return {
    fetchOrderStatus,
    payOrderStatus,
    createSourceStatus,
    fetchOrderError,
    payOrderError,
    createSourceError,
    ...paymentSelector(state),
  };
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Payment);



// WEBPACK FOOTER //
// ./src/containers/payment.js